import { useEffect, useState } from "react";
import {
  Layout,
  Avatar,
  Dropdown,
  Space,
  Typography,
  Badge,
  Input,
  List,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  ShoppingCartOutlined,
  MenuOutlined,
  SearchOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

import { BellOutlined } from "@ant-design/icons";

import api from "../services/api";

const { Header } = Layout;
const { Text } = Typography;

export default function AppHeader({ onMenuClick, isMobile }) {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const [unreadCount, setUnreadCount] = useState(0);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const t = setTimeout(() => {
      if (search.length >= 3) {
        navigate(`/search?q=${search}`);
      }
    }, 400);

    return () => clearTimeout(t);
  }, [search]);

  const handleSearch = (value) => {
    if (value.length < 3) return;
    navigate(`/search?q=${value}`);
  };

  const { count } = useCart(); // ✅ single source

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const items = [
    {
      key: "profile",
      label: "My Profile",
      onClick: () => navigate("/profile"),
    },
    ...(user?.role === "customer"
      ? [
          {
            key: "my-orders",
            label: "My Order",
            onClick: () => navigate("/my-orders"),
          },
        ]
      : []),

    { type: "divider" },

    {
      key: "logout",
      label: (
        <span style={{ color: "red" }}>
          <LogoutOutlined /> Logout
        </span>
      ),
      onClick: logout,
    },
  ];

  const notificationMenu = {
    items: [
      {
        key: "notifications",

        label: (
          <div
            style={{
              width: 320,
              maxHeight: 400,
              overflowY: "auto",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                marginBottom: 10,
              }}
            >
              Recent Orders
            </div>

            <List
              dataSource={notifications}
              locale={{
                emptyText: "No notifications",
              }}
              renderItem={(item) => (
                <List.Item
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/my-orders")}
                >
                  <List.Item.Meta
                    title={item.title}
                    description={item.description}
                  />
                </List.Item>
              )}
            />
          </div>
        ),
      },
    ],
  };

  return (
    <Header
      style={{
        background: "#a8a0c9",
        padding: "0 10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "nowrap", // ✅ IMPORTANT (no wrapping)
        position: "sticky",
        top: 0,
        zIndex: 9,
      }}
    >
      {/* ✅ LEFT: Menu + Logo */}
      <Space size="small" style={{ alignItems: "center" }}>
        {isMobile && (
          <MenuOutlined
            style={{ fontSize: 20, cursor: "pointer", color: "#fff" }}
            onClick={onMenuClick}
          />
        )}

        {user?.role === "customer" && (
          <Link to="/home" style={{ textDecoration: "none" }}>
            <div
              style={{
                fontSize: isMobile ? 20 : 32,
                fontWeight: 600,
                lineHeight: 1,
              }}
            >
              <span style={{ color: "#3c2a98" }}>MY</span>
              <span style={{ color: "#de2a1b" }}>FONE</span>
            </div>
          </Link>
        )}
      </Space>

      {/* ✅ RIGHT: Actions */}
      <Space size={isMobile ? "middle" : "large"} align="center">
        {/* ❌ HIDE SEARCH ON MOBILE */}
        {/* Desktop Search */}
        {!isMobile && user?.role === "customer" && (
          <Input.Search
            placeholder="Search products..."
            style={{ width: 200, marginTop: 16 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onSearch={handleSearch}
            allowClear
          />
        )}

        {/* Mobile Search */}
        {isMobile && user?.role === "customer" && (
          <>
            {!mobileSearchOpen ? (
              <SearchOutlined
                style={{
                  fontSize: 20,
                  color: "#fff",
                  cursor: "pointer",
                }}
                onClick={() => setMobileSearchOpen(true)}
              />
            ) : (
              <Space size={4}>
                <Input.Search
                  autoFocus
                  placeholder="Search..."
                  size="small"
                  style={{ width: 180, marginTop: 20 }}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onSearch={handleSearch}
                  allowClear
                />

                <CloseOutlined
                  style={{
                    color: "#fff",
                    cursor: "pointer",
                    fontSize: 16,
                  }}
                  onClick={() => {
                    setMobileSearchOpen(false);
                    setSearch("");
                  }}
                />
              </Space>
            )}
          </>
        )}
        {!isMobile && (user?.role === "admin" || user?.role === "manager") && (
          <Dropdown
            menu={notificationMenu}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Badge count={unreadCount} size="small">
              <BellOutlined
                style={{
                  fontSize: 20,
                  cursor: "pointer",
                  marginRight: 0,
                  color: "white",
                }}
              />
            </Badge>
          </Dropdown>
        )}
        {/* 👤 Username (optional hide on very small screens) */}
        {!(isMobile && mobileSearchOpen) && (
          <>
            {!isMobile && (
              <Text strong style={{ color: "#fff" }}>
                {user?.name}
              </Text>
            )}

            {user?.role === "customer" && (
              <Badge count={count} overflowCount={99}>
                <ShoppingCartOutlined
                  style={{
                    fontSize: isMobile ? 20 : 22,
                    color: "#fff",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/cart")}
                />
              </Badge>
            )}

            <Dropdown menu={{ items }} placement="bottomRight">
              <Avatar style={{ cursor: "pointer" }} icon={<UserOutlined />} />
            </Dropdown>
          </>
        )}
      </Space>
    </Header>
  );
}
